module.exports = __webpack_public_path__ + "static/img/BG_d@2x.42dbc69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/BG_d@2x.png
// module id = LcAF
// module chunks = 69